<ts-input-field
  [field]="{
    formControl,
    props: inputFieldProps,
  }"
></ts-input-field>
